import React, { useState } from 'react';
import { useUISettings } from '../../context/UISettingsContext';
import { Button } from '../common/Button';

export function RecoveryCodesModal() {
  const { 
    isRecoveryModalOpen, 
    setIsRecoveryModalOpen, 
    recoveryCodes, 
    regenerateRecoveryCodes,
    showNotification 
  } = useUISettings();
  const [copied, setCopied] = useState(false);
  const [copyAllText, setCopyAllText] = useState('Copy All Codes');

  if (!isRecoveryModalOpen) return null;

  const handleCopyAll = () => {
    navigator.clipboard.writeText(recoveryCodes.join('\n'));
    setCopied(true);
    setCopyAllText('All Codes Copied!');
    showNotification('All recovery codes copied to clipboard!', 'success');
    setTimeout(() => {
      setCopied(false);
      setCopyAllText('Copy All Codes');
    }, 2000);
  };

  const handleCopySingle = (code, index) => {
    navigator.clipboard.writeText(code);
    showNotification(`Code ${index + 1} copied to clipboard!`, 'success');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg shadow-2xl w-full max-w-md">
        <div className="text-center mb-6">
          <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-purple-600" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2.586a1 1 0 01-.707-.293l-1.121-1.121A2 2 0 0011.172 2H8.828a2 2 0 00-1.414.586l-1.121 1.121A2 2 0 005.586 4H4zm6 3a4 4 0 100 8 4 4 0 000-8zm0 2a2 2 0 110 4 2 2 0 010-4z" clipRule="evenodd" />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-gray-800">Recovery Codes</h3>
        </div>
        
        <div className="bg-red-50 border-l-4 border-red-400 p-4 mb-6">
          <p className="text-sm text-red-700 font-semibold mb-2">
            ⚠️ CRITICAL: Save these recovery codes
          </p>
          <p className="text-xs text-red-600">
            Each code can be used ONCE to recover your account if you lose your session token or password.
            Store them securely. These will not be shown again.
          </p>
        </div>
        
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Your Recovery Codes:
          </label>
          <div className="bg-gray-100 p-4 rounded-lg font-mono text-sm space-y-2 max-h-64 overflow-y-auto">
            {recoveryCodes.map((code, index) => (
              <div key={index} className="flex items-center">
                <span className="w-8 text-gray-500">{index + 1}.</span>
                <span className="flex-1">{code}</span>
                <button
                  onClick={() => handleCopySingle(code, index)}
                  className="text-blue-500 hover:text-blue-600 text-xs px-2 py-1"
                >
                  Copy
                </button>
              </div>
            ))}
          </div>
          <button
            onClick={handleCopyAll}
            className={`mt-2 w-full py-2 rounded-lg transition ${
              copied ? 'bg-green-500' : 'bg-blue-500 hover:bg-blue-600'
            } text-white`}
          >
            {copyAllText}
          </button>
        </div>
        
        <div className="flex space-x-4">
          <Button
            onClick={regenerateRecoveryCodes}
            variant="warning"
            className="flex-1"
          >
            Regenerate Codes
          </Button>
          <Button
            onClick={() => setIsRecoveryModalOpen(false)}
            variant="success"
            className="flex-1"
          >
            I've Saved Them
          </Button>
        </div>
      </div>
    </div>
  );
}